import axiosInstance from "./axiosInstance";

const BASE_URL = "/auth";

// Kiểm tra đăng nhập bằng email, mật khẩu
// device_fingerprint + device_class: bắt buộc cho tài khoản GV đối tác trên server
export const loginUser = async ({
  email,
  password,
  device_fingerprint,
  device_class,
  app_audience = "erp",
}) => {
  const response = await axiosInstance.post(`${BASE_URL}/login`, {
    email,
    password,
    device_fingerprint,
    device_class,
    app_audience,
  });
  return response.data;
};

// Lấy danh sách chi nhánh hiện hành
export const getBranches = async () => {
  const response = await axiosInstance.get(`${BASE_URL}/branches`);
  return response.data;
};

// Quên mật khẩu
export const forgotPassword = async (email) => {
  const res = await axiosInstance.post(`${BASE_URL}/forgot-password`, { email });
  return res.data;
};

// Reset mật khẩu
export const resetPassword = async ({ token, newPassword }) => {
  const response = await axiosInstance.post(`${BASE_URL}/reset-password`, {
    token,
    newPassword,
  });
  return response.data;
};

// Gửi yêu cầu đăng ký
export const sendRegisterRequest = async ({ name, email, phone, otherInfo }) => {
  return await axiosInstance.post(`${BASE_URL}/register-request`, {
    name,
    email,
    phone,
    otherInfo,
  });
};

/** Nhật ký đăng nhập của tài khoản hiện tại */
export const getMyLoginLogs = async ({ page = 1, limit = 8 } = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/me/login-logs`, {
    params: { page, limit },
  });
  return res.data;
};

/** Thiết bị đã đăng ký / gần đây của tài khoản hiện tại */
export const getMyDevices = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/me/devices`);
  return res.data;
};
